import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import iconoApp from './assets/icono.png';

export default function SignUpScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validatePassword = (pwd) => {
    if (pwd.length < 6) return 'Password must be at least 6 characters';
    return null;
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email.trim()) {
      setError('Email is required');
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      setLoading(false);
      return;
    }

    const { data, error: signUpError } = await supabase.auth.signUp({
      email,
      password
    });

    if (signUpError) {
      console.log('SignUp error:', signUpError);
      if (signUpError.message.includes('already registered')) {
        setError('Email already registered. Please log in or use a different email.');
      } else if (signUpError.message.includes('weak password')) {
        setError('Password is too weak. Use at least 6 characters.');
      } else {
        setError(signUpError.message || 'Sign up failed. Please try again.');
      }
      setLoading(false);
      return;
    }

    setSuccess(true);
    setLoading(false);
    setTimeout(() => {
      navigate('/login');
    }, 2000);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f4f2ed'
    }}>
      <div style={{
        background: '#ffffff', border: '1px solid #d4d0c8',
        borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={iconoApp} alt="logo" style={{ width: '48px', marginBottom: '12px' }} />
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1c1e' }}>
            Wind<span style={{ color: '#c96a10' }}>Manager</span> Pro
          </div>
          <div style={{ color: '#7a7a72', fontSize: '0.85rem', marginTop: '4px' }}>
            Create Manager Account
          </div>
        </div>

        {success ? (
          <div style={{ color: '#2e7d32', fontSize: '0.9rem', textAlign: 'center' }}>
            Account created successfully! Redirecting to login...
          </div>
        ) : (
          <form onSubmit={handleSignUp}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                Email
              </label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                required placeholder="manager@email.com"
                style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                Password
              </label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                required placeholder="••••••••"
                style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                Confirm Password
              </label>
              <input
                type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                required placeholder="••••••••"
                style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                  border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                  fontSize: '0.9rem', boxSizing: 'border-box' }}
              />
            </div>

            {error && (
              <div style={{ color: '#c0392b', fontSize: '0.85rem',
                marginBottom: '16px', textAlign: 'center' }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px', background: '#3d7a2e',
              border: 'none', borderRadius: '6px', color: '#fff',
              fontSize: '0.95rem', fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1
            }}>
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>
        )}

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <button
            onClick={() => navigate('/login')}
            style={{ background: 'none', border: 'none', color: '#c96a10',
              fontSize: '0.85rem', cursor: 'pointer', padding: 0 }}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}
